function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { elo as theme } from '../../themes';
import SpinnerSVG from './SpinnerSVG';
import { SpinnerContainer } from './styled';
import Popover from '../Popover/Popover';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Spinner = function Spinner(props) {
  var _useState = useState('running'),
    animationPlayState = _useState[0],
    setAnimationPlayState = _useState[1];
  var memoColor = useMemo(function () {
    if (props.inverted && !props.popover) {
      return theme.colors.white;
    }
    return theme.colors.brand30;
  }, [props.inverted, props.popover]);
  var toggleAnimationPlayState = function toggleAnimationPlayState() {
    return setAnimationPlayState(function (oldState) {
      return oldState === 'paused' ? 'running' : 'paused';
    });
  };
  var renderSpinner = function renderSpinner() {
    return ___EmotionJSX(SpinnerContainer, _extends({}, props, {
      animationPlayState: animationPlayState,
      "data-test-id": props.dataTestId,
      onClick: toggleAnimationPlayState
    }), ___EmotionJSX(SpinnerSVG, {
      color: memoColor,
      dataTestId: props.dataTestId,
      size: props.size
    }));
  };
  if (props.popover && !props.inverted) {
    return ___EmotionJSX(Popover, {
      dataTestId: props.dataTestId + "-popover",
      circle: true
    }, renderSpinner());
  }
  return renderSpinner();
};
Spinner.propTypes = {
  dataTestId: PropTypes.string,
  inverted: PropTypes.bool,
  popover: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'large'])
};
Spinner.defaultProps = {
  size: 'small'
};
export default Spinner;